<template>
    <div>
        <div class="searchGood" ref="container">
            <div class="search acea-row row-between-wrapper bg-color">
                <div class="input acea-row row-between-wrapper">
                    <span class="iconfont icon-sousuo2"></span>
                    <form @submit.prevent="submit"></form>
                    <input
                        type="text"
                        placeholder="输入视频名称"
                        v-model="name"
                    />
                </div>
                <div class="bnt" @click="submit">搜索</div>
            </div>
            <div class="line"></div>
        </div>
        <div class="video-list">
            <van-tabs title-active-color="#d01112" @click="select" ref="container">
                <van-tab
                    v-for="(item, index) in videoSource"
                    :title="item.name"
                    :key="index"
                >
                </van-tab>
            </van-tabs>
        </div>
        <div class="video-list-list row-flex row-between-center row-wrap">
            <div
                class="video-li"
                v-for="(item, index) in orderList"
                :key="index"
                @click="selectVideo(item.video_link)"
            >
                <img :src="item.image" class="poster" alt="" />
                <img src="../assets/images/videos.png" class="video" alt="" />
                <div class="line l-1 row-flex row-center-center">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <div class="no-show" v-if="orderList.length==0 && loaded">
            <img src="../assets/newImg/no_show.png" alt="">
        </div>
        <div class="loading-more" v-if="loaded">暂无更多了</div>
        <van-overlay :show="show" @click="close">
            <div class="wrapper row-flex row-center-center" @click="close">
                <img
                    src="../assets/newImg/video_close.png"
                    class="close"
                    alt=""
                    @click="close"
                />
                <video
                    id="myVideo"
                    class="video-js"
                    controlslist="nofullscreen"
                    controls
                    autoplay
                    :src="link"
                    webkitplaysinline playsinline x5-playsinline x-webkit-airplay="allow"
                ></video>
            </div>
        </van-overlay>
    </div>
</template>
<style>

</style>
<style lang="scss" scoped>
.wrapper {
    width: 80%;
    height: 500px;
    margin: auto;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    .video-js {
        width: 100%;
        height: 100%;
        background: #000;
    }
    .close {
        width: 40px;
        height: 40px;
        position: absolute;
        top: -50px;
        right: -30px;
    }
}
.searchGood .search {
    margin-top: 0;
    height: 44px;
    line-height: 44px;
}
.searchGood .search .bnt {
    color: #fff;
}
.searchGood .search .input {
    line-height: 0.66rem;
}
.video-list >>> .van-tab--active {
    font-size: 16px;
}
.video-list {
    background: #ffffff;
    box-shadow: 0px 2px 5px 0px rgba(173, 39, 39, 0.06);
}
.searchGood .search .input {
    background: rgba(255, 255, 255, 0.4);
    input {
        color: #fff;
        &::placeholder {
            color: #fff;
        }
    }
    .iconfont {
        color: #fff;
    }
}
.video-list-list {
    margin: 15px 12px 20px 12px;
    .video-li {
        width: 3.4rem;
        height: 3rem;
        background: #ffffff;
        border-radius: 6px;
        position: relative;
        margin-bottom: 10px;
        .poster {
            width: 100%;
            height: 2rem;
            object-fit: cover;
        }
        .video {
            width: 40px;
            height: 40px;
            position: absolute;
            top: 0.6rem;
            left: 0;
            right: 0;
            margin: 0 auto;
        }
        div {
            height: 1rem;
            font-size: 14px;
            color: #3e4045;
        }
    }
}
.searchGood .line{
    margin: 0;
}
</style>
<script>
import Vue from "vue";
import { Tab, Tabs, Overlay } from "vant";
import { videoCate, videoLists } from "@api/user";
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Overlay);
export default {
    name: "videoList",
    data() {
        return {
            show: false,
            videoSource: [],
            index: 0,
            page: 1,
            limit: 10,
            name: "",
            loading: false,
            loaded: false,
            cate_id: "",
            orderList: [],
            link: "", //视频链接
        };
    },
    methods: {
        show() {},
        submit() {
            this.page = 1;
            this.loading = false;
            this.loaded = false;
            this.orderList = [];
            this.getOrderList();
        },
        /**视频分类 */
        videoList() {
            videoCate().then((res) => {
                this.videoSource = res.data;
                this.videoSource.unshift({id:'',name:'全部视频'})
                console.log("111=>",this.videoSource)
                this.cate_id = res.data[0].id;
                this.getOrderList();
            });
        },
        select(e) {
            this.index = e;
            this.cate_id = this.videoSource[e].id;
            this.page = 1;
            this.loading = false;
            this.loaded = false;
            this.orderList = [];
            this.getOrderList();
        },
        /**视频列表 */
        getOrderList() {
            const { page, limit, name, cate_id } = this;
            if (this.loading || this.loaded) return;
            this.loading = true;
            videoLists({
                page,
                limit,
                name,
                cate_id,
            }).then((res) => {
                this.orderList = this.orderList.concat(res.data);
                this.loading = false;
                this.loaded = res.data.length < limit;
                this.page++;
            });
        },
        /**打开链接 */
        selectVideo(link) {
            this.link = link;
             this.$dialog.loading.open('加载中...');

                setTimeout(() => {
                    this.$dialog.loading.close();
                    document.getElementById("myVideo").play();
                    this.show = true;
                }, 1500);

        },
        /**关闭视频 */
        close() {
            document.getElementById("myVideo").pause();
            this.show = false;
        },
    },
    mounted() {
        this.videoList();
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.getOrderList();
        });
    },
}
</script>
